import {SimplePresentation} from "./SimplePresentationRunner";
import {Decadence} from "../../Decadence";
import {gsap} from "gsap"
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class DecadenceFSOutroPresentation extends SimplePresentation {

    constructor() {
        super("FreespinsOutroPresentation", false);
    }

    shouldRun(): boolean {
        return Decadence.model.isFreeSpins && Decadence.model.data.freespinsLeft == 0 && !Decadence.model.brokeTheBank;
    }
    buildTimeline() {
        const tl = this.tl;
        this.tl.eventCallback("onComplete", () => {});
        tl.add(() => {
            Decadence.keypadPlugin.setZeroBetSpinCounter(-1);
            Decadence.soundPlayer.switchMusic("FS_OUTRO");

            Decadence.soundPlayer.playSound("fsEnds");
            Decadence.soundPlayer.playSound("fsOutroSplash");
            if(!Decadence.model.winBelowStake) {
                Decadence.soundPlayer.playSound("fsOutroWin");
            }
        })

        tl.add(Decadence.reelView.playMonsterFallAsleep());
        tl.add(Decadence.backgroundElements.transitionMode(GameMode.NORMAL), "<");
        tl.add(Decadence.transitionScreen.darken(0.2), "<");
        tl.add(Decadence.transitionScreen.showFSOutro(), "<");
        tl.add(Decadence.transitionScreen.enableButton(() => this.onButtonPressed()));
    }

    onButtonPressed() {
        const tl = gsap.timeline();
        tl.add(<any>Decadence.keypadPlugin.show(0.2));
        tl.add(Decadence.transitionScreen.hide())
        tl.add(() => {
            Decadence.soundPlayer.switchMusic(GameMode.NORMAL);
            Decadence.soundPlayer.fadeInMusic();
            this.controller.finish();
        })
    }
}